import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, of, tap } from 'rxjs';
import { environment } from '../../../environments/environment.development';
import { Service, ServiceInput } from '../models/service.models';

@Injectable({
  providedIn: 'root'
})
export class ServicesService {

  constructor(
    private http: HttpClient
  ) { }

  getServicesForProject(projectId: string): Observable<Service[]> {
    return this.http.get<Service[]>(`${environment.baseUrl}/projects/${projectId}/services`)
      .pipe(
        catchError(this.handleError<Service[]>('getServicesForProject'))
      );
  }

  getServiceById(projectId: string, serviceId: string): Observable<Service> {
    return this.http.get<Service>(`${environment.baseUrl}/projects/${projectId}/services/${serviceId}`)
      .pipe(
        catchError(this.handleError<Service>('getServiceById'))
      );
  }

  createService(projectId: string, service: ServiceInput): Observable<Service> {
    return this.http.post<Service>(`${environment.baseUrl}/projects/${projectId}/services`, service)
      .pipe(
        catchError(this.handleError<Service>('createService'))
      );
  }

  updateService(projectId: string, serviceId: string, service: ServiceInput): Observable<Service> {
    return this.http.put<Service>(`${environment.baseUrl}/projects/${projectId}/services/${serviceId}`, service)
      .pipe(
        catchError(this.handleError<Service>('updateService'))
      );
  }

  deleteService(projectId: string, serviceId: string): Observable<any> {
    return this.http.delete<Service>(`${environment.baseUrl}/projects/${projectId}/services/${serviceId}`)
      .pipe(
        catchError(this.handleError<any>('deleteService'))
      );
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}


